'use strict';

const DashboardView = require('./views/dashboard-view');
const UsersView = require('./views/users-view');
const LeaderboardsView = require('./views/leaderboards-view');
const ConfigView = require('./views/config-view');

class AdminApp {
  constructor(api, user) {
    this.api = api;
    this.user = user;
    this.views = {
      dashboard: new DashboardView(api),
      users: new UsersView(api, user),
      leaderboards: new LeaderboardsView(api),
      config: new ConfigView(api)
    };
    this.current = null;
  }

  start() {
    document.getElementById('admin-name').textContent = this.user.username;
    Object.values(this.views).forEach((view) => view.bind());
    document.querySelectorAll('.nav-button').forEach((button) => {
      button.addEventListener('click', () => this.show(button.dataset.view));
    });
    document.querySelectorAll('.dialog-close').forEach((button) => {
      button.addEventListener('click', () => button.closest('dialog').close());
    });
    this.show('dashboard');
  }

  show(name) {
    if (!this.views[name]) return;
    Object.entries(this.views).forEach(([key, view]) => {
      if (key === name) view.show(); else view.hide();
    });
    document.querySelectorAll('.nav-button').forEach((button) => {
      button.classList.toggle('active', button.dataset.view === name);
    });
    this.current = name;
  }
}

module.exports = AdminApp;
